<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('customer.invoices.title') }}
        </h2>
      </div>
      <div
        v-if="loadingList"
        class="eu-pa_6 eu-align_center"
      >
        <emd-loader :type="'_invert'"></emd-loader>
      </div>
      <div
        v-else
        class="emd-table-responsive"
      >
        <Table
          :fields="fields"
          :items="invoices.items"
          :toDetail="permissionIsEnabled('invoice:get') && toDetail"
        ></Table>
        <empty-list
          v-if="!loadingList && showEmptyList()"
          entity="invoices"
        ></empty-list>
      </div>
      <pagination
        v-if="!loadingList"
        :pagination="invoices.pagination"
        :totalShowing="totalItems"
        :type="'list'"
        :action="action"
      ></pagination>
    </div>
  </div>
</template>
<script>
import { EmdLoader } from 'emerald-vue/src/components'
import EmptyList from '@/components/project/globals/EmptyList.vue'
import Pagination from '@/components/project/globals/Pagination.vue'
import Table from '@/components/project/molecules/Table.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'CustomersInvoices',
  components: {
    EmdLoader,
    EmptyList,
    Pagination,
    Table
  },
  data () {
    return {
      action: 'GET_INVOICES',
      fields: [
        {
          id: 'code',
          label: 'customer.invoices.code',
          type: 'text'
        },
        {
          id: 'amount',
          label: 'customer.invoices.amount',
          type: 'text'
        },
        {
          id: 'status',
          label: 'customer.invoices.status',
          type: 'status'
        },
        {
          id: 'due_at',
          label: 'customer.invoices.due-at',
          type: 'date',
          format: 'date'
        },
        {
          id: 'payment_method',
          label: 'customer.invoices.payment-method',
          type: 'text'
        },
        {
          id: 'created_at',
          label: 'customer.invoices.created-at',
          type: 'date',
          format: 'dateAndHour'
        }
      ],
      toDetail: {
        name: 'invoicesDetail',
        params: {
          id: 'id'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['merchant', 'account', 'invoices', 'loadingListInvoices']),
    totalItems () {
      return this.invoices.items.length
    },
    loadingList () {
      return this.loadingListInvoices
    }
  },
  methods: {
    showEmptyList () {
      return (
        !this.loadingList &&
        this.invoices.pagination &&
        this.invoices.pagination.total_items === 0
      )
    },
    permissionIsEnabled (action) {
      return this.$store.getters.permissionIsEnabled(action)
    }
  },
  created () {
    const query = {
      customer_id: this.$route.params.id,
      page: this.$route.query.page || 1
    }
    const params = {
      merchantId: this.merchant.id,
      accountId: this.account.id,
      query
    }
    this.$router.replace({ query: query }).catch(err => err)
    this.$store.dispatch('GET_INVOICES', params)
  }
}
</script>
